import { Box } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import React, { useMemo } from 'react';

type EventCounts = {
  lpr?: number;
  face?: number;
  ivs?: number;
  temp?: number;
  total?: number;
}

type Props = {
  events?: EventCounts | null;
}

const PieChartLastEventsType: React.FC<Props> = ({ events = null }) => {
  const data = useMemo(
    () => [
      { label: 'Eventos LPR', value: events?.lpr ?? 0 },
      { label: 'Eventos Faciais', value: events?.face ?? 0 },
      { label: 'Eventos IVS', value: events?.ivs ?? 0 },
      { label: 'Eventos Temp', value: events?.temp ?? 0 },
    ],
    [events?.lpr, events?.face, events?.ivs, events?.temp]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#202940',
        width: '100%',
        height: '100%',
        borderRadius: 3,
        boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
        padding: 2,
      }}
    >
      <PieChart
        series={[
          {
            data: data,
            highlightScope: { fade: 'global', highlight: 'item' },
            faded: {
              innerRadius: 30,
              additionalRadius: -30,
              color: 'gray',
            },
            valueFormatter: (value) => value.toString(),
          },
        ]}
        height={200}
      />
    </Box>
  );
};

export default PieChartLastEventsType;
